var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"c-open-reporting",attrs:{"role":"button"},on:{"click":_vm.openReporting}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }